import { render, staticRenderFns } from "./CircularProgress.vue?vue&type=template&id=70b0e990&scoped=true"
import script from "./CircularProgress.vue?vue&type=script&lang=js"
export * from "./CircularProgress.vue?vue&type=script&lang=js"
import style0 from "./CircularProgress.vue?vue&type=style&index=0&id=70b0e990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0e990",
  null
  
)

export default component.exports